import type { TFileUploadModel } from '../../../utils/hookUtils';
import { parseVendorCodesCommercialHomeWarrantyCsvFile } from './../../../services/VendorCodesService';
import { useMutation } from 'react-query';

const useParseVendorCodesCommercialHomeWarrantyCsvFile = (): TFileUploadModel<File> => {
  const { isLoading, mutate } = useMutation(parseVendorCodesCommercialHomeWarrantyCsvFile);

  return {
    upload: mutate,
    isLoading,
  };
};

export default useParseVendorCodesCommercialHomeWarrantyCsvFile;
